<template>
    <div>
        <input type="text"
            v-model="current_value"
            class="form-control tip"
            :required="field.required"
            :readonly="field.readonly"
            :disabled="field.disabled"
            :data-original-title="field.help"
            data-placement="bottom"
            data-toggle="tooltip"
            :placeholder="field.placeholder"
            @input="updateFromTextArea"
            @focus="hasFocus = true"
            @blur="hasFocus = false">

        <div v-if="zipcodeHelpDisplayed" class="alert alert-info" style="margin-top: 10px; margin-bottom: 7px;">
            Le Code postal doit obligatoirement être correct pour l'enregistrement du client dans SAP. 
            En cas de doute sur le code postal, merci de vérifier son exactitude sur Internet avant de continuer.
        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomText",

        props: [
            "field", "value", "field_idx"
        ],

        data() {
            return {
                current_value: this.value,
                hasFocus: false
            }
        },

        computed: {
            zipcodeHelpDisplayed() {
                return this.field.hasOwnProperty('model') && this.field.model.indexOf('zipcode') !== -1 && this.hasFocus
            }
        },

        methods: {
            updateFromTextArea() {
                this.$emit("field-updated", {type:this.field.type, idx:this.field_idx, new_value:this.current_value})
            }
        },

        watch: {
            value() {
                this.current_value = this.value
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Forms/Elements/Text.vue